import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";

import CloseIcon from "../Common/CloseIcon";
import { I18n } from "@aws-amplify/core";
import Button from '@material-ui/core/Button';

import images from "../../assets/img/images";
import { fetchPatch } from "../../api/fetch";


const styles = {
    container: {
        width: 367,
        height: 250
    },
    close: {
        float: "right",
        margin: 10,
        display: "inline",
    },
    warning: {
        right: -180,
        top: 80
    },
    warningMessage: {
        top: 100,
        left: 45,
        width: "280px",
    },
    buttons: {
        display: "table",
        margin: "0 auto",
        left: 30,
        top: 152
    }
};

const DissociateProduct = withStyles(styles)((props) => {
    const {
        classes,
        handleClose,
        id,
        removeProduct
    } = props;

    const [error, setError] = React.useState(false)


    async function processRequest() {
        try {
            await fetchPatch(
                `product_zone_inventory/${id}`,
                {
                    "active": false
                }
            );
            removeProduct();
            handleClose();
        } catch (error) {
            console.log(error)
            setError(true)
        }

    }

    return (
        <div className={classes.container}>
            <div className={classes.close}>
                <CloseIcon closeFunction={handleClose} />
            </div>
            <div style={{ height: 0 }}>
                <img src={!error ? images.warningTriangleOrange : images.deleteWarningTriangle} className={classes.warning} alt="warning"></img><br />
                <div className={classes.warningMessage}>{!error ? I18n.get("diss_warning") : I18n.get("order_in_progress_warning")}</div>
            </div>

            {!error ?
            <div className={classes.buttons}>
                <Button onClick={() => { handleClose() }} color="primary">
                    {I18n.get("site_cancel")}
                </Button>
                <Button onClick={() => { processRequest() }} style={{ top: "-4px", left: "14px" }} variant="contained" color="primary">
                    {I18n.get("site_confirm")}
                </Button>
            </div>
            : null }


        </div>
    );

});

export default withRouter(DissociateProduct);
